import client from '/src/services/client.js';

export default {
    addBot : (data) => client.post('bot',data),
    getBots : (data) => client.get('bots', data),
    updateBot : (id,data) => client.put(`bot/${id}`, data),
    deleteBot : (id,data) => client.delete(`bot/${id}`,data),
    getBotsChannels : () => client.get('bots', ["channels"]),
    isBotNameAvailable : (name) => client.get(`bots?name=${name}`),
    getVoices: (id) => client.get(`bot/voices`),
    getBotsShared: (data)=> client.get(`bots/dashboards`,data),
}